<p-dropdown
  #dropdown
  i18n-placeholder
  placeholder="{{ placeholder }}"
  [style]="{ width: '100%' }"
  [options]="options"
  [filterBy]="filterBy"
  [(ngModel)]="selectedValue"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [dropdownIcon]="getDropdownIcon()"
  (onShow)="toggleDropdown(true)"
  (onHide)="toggleDropdown(false)"
  (onChange)="buttonClick.emit($event)"
>
  <ng-template [pTemplate]="'header'">
    <div [style]="{ textAlign: 'end' }">
      <lx-button [svg]="'remove'" [hasText]="false" [svgColor]="'dark'" [btnRounded]="true" [buttonStyle]="'plain-text'" (buttonClick)="toggleDropdown(false)">
      </lx-button>
    </div>
  </ng-template>
  <ng-template [pTemplate]="'selectedItem'" let-data>
    <div class="dropdown-country__option">
      <img
        class="dropdown-country__country-flag"
        src="/assets/images/flags-icon/{{ countryMap ? (countryMap[selectedValue.value] | lowercase) : data?.code }}.png"
        alt="Selected flag country"
      />
      <div class="dropdown-country__option-label">{{ isOpened ? pleaseSelect : countryMap ? selectedValue.label : data?.name }}</div>
    </div>
  </ng-template>
  <ng-template [pTemplate]="'item'" let-data>
    <div class="dropdown-country__option">
      <img
        class="dropdown-country__option-flag"
        src="/assets/images/flags-icon/{{ countryMap ? (countryMap[data?.value] | lowercase) : data?.code }}.png"
        alt="Selected flag country"
      />
      <div class="dropdown-country__option-label">{{ countryMap ? data?.label : data?.name }}</div>
    </div>
  </ng-template>
</p-dropdown>
